import { useEffect } from "react";
import { useFormState, useWatch } from "react-hook-form";
import { useDispatch } from "react-redux";

export const DraftWatcher = ({ control }) => {
  const formValues = useWatch({ control });
  const { isDirty } = useFormState({ control });

  const dispatch = useDispatch();

  useEffect(() => {
    if (isDirty)
      dispatch({ type: "SAVE-DRAFT-PHIEU-DAT-HANG", payload: formValues });
  }, [formValues, isDirty]);

  return <></>;
};
